<div class="app-container">

  <!-- Navy utility bar -->
  <div class="app-utilitybar">Cordell &amp; Cordell · Scheduling Tools</div>

  <!-- Main header -->
  <header class="app-header">
    <div class="header-content">
      <div class="app-brand">
        <img class="app-logo" src="assets/cc-logo.png" alt="Cordell &amp; Cordell">
        <span class="app-brand__divider"></span>
        <div class="app-brand__text">
          <span class="app-brand__eyebrow">Scheduling</span>
          <span class="app-brand__title">{{ title }}</span>
        </div>
      </div>

      @if (isUserAuthenticated) {
        <div class="auth-section">
          <span class="username">Welcome, <strong>{{ username }}</strong></span>
          <button class="logout-btn" (click)="logout()">Logout</button>
        </div>
      } @else {
        <div class="auth-section">
          <button class="login-btn" (click)="login()">Login</button>
        </div>
      }
    </div>
  </header>

  <main class="app-main">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer class="app-footer">
    <span>© 2025 Cordell &amp; Cordell. Internal use only.</span>
    <span>Selection App · v2.4.0</span>
  </footer>

</div>
